import React, { useEffect, useState } from "react";
import {
  Button,
  Divider,
  Grid,
  Typography,
  Autocomplete,
  Checkbox,
  FormControlLabel,
  Pagination,
} from "@mui/material";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import ParentCard from "src/components/shared/ParentCard";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate } from "react-router";
import swal from "sweetalert";
import { IconArrowBack } from "@tabler/icons";
import MasterListService from "src/service/masterList";
import GeofencingService from "src/service/geofencing";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: "Geofence Allotment to Vehicle",
  },
];

const validationSchema = yup.object({
  geofenc_id: yup.string().required("Geo fencing is required"),
  alert_short_name: yup.string().required("Alert Type is required"),
});

const FencingAllottoMultipleVehicle = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  const [geofenc, setGeofenc] = useState([]);
  const [alert_list, setAlert_list] = useState([]);
  const [vehicleList, setVehicleList] = useState([]);
  const [filteredVehicles, setFilteredVehicles] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(60);

  const fetchGeofenceList = async () => {
    try {
      const res = await MasterListService.detgeofenceList({});
      console.log("res.data---", res.data);
      setGeofenc(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchAlertList = async () => {
    try {
      const res = await GeofencingService.fetch_alert_list({});
      const filteredAlerts = res.data.filter((alert) => {
        return ["LCN", "HMST", "RST"].includes(alert.alert_short_name);
      });
      setAlert_list(filteredAlerts);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDistrictList = async () => {
    try {
      const res = await GeofencingService.fetch_district_list({});
      setDistrictList([{ id: "", district_name: "All" }, ...res.data]);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchVehicleList = async (id) => {
    try {
      const district_id = user_type === 3 ? sessionData.data.district_id : id;
      const res = await GeofencingService.fetch_vehicle_list({
        district_code: district_id,
      });
      setVehicleList(res.data);
      setFilteredVehicles(res.data); // Initially set all vehicles
    } catch (error) {
      console.log(error);
    }
  };

  const initialValues = {
    geofenc_id: "",
    vehicle_no: [],
    alert_short_name: "",
    c_by: sessionData.data.id,
  };

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: async (values) => {
        const { district_code, search, ...finalValues } = values;
        try {
          const res = await GeofencingService.save_multiple_vehicle(
            finalValues
          );
          swal("success", res.message, "success");
          // Reset form values
          values.geofenc_id = "";
          values.alert_short_name = "";
          values.vehicle_no = [];
          setTimeout(() => {
            navigate("/geofencereport");
          }, 1000);
        } catch (error) {
          swal("error", error, "error");
        }
      },
    });

  useEffect(() => {
    fetchGeofenceList();
    fetchDistrictList();
    fetchAlertList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionData.data.id, sessionData.data.user_type]);

  const user_type = sessionData.data.user_type;

  useEffect(() => {
    if (user_type === 3) {
      fetchVehicleList();
    }
  }, [user_type]);

  // Handle district selection change
  const handleDistrictChange = async (event, newValue) => {
    handleChange({
      target: {
        name: "district_code",
        value: newValue ? newValue.id : "",
      },
    });
    try {
      await fetchVehicleList(newValue ? newValue.id : "");
    } catch (error) {
      console.error("Error fetching vehicles:", error);
    }
  };

  // Filter vehicles based on search query
  useEffect(() => {
    const filtered = vehicleList.filter((vehicle) =>
      vehicle.vehicle_no.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredVehicles(filtered);
  }, [searchQuery, vehicleList]);

  // Handle search input change
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    handleChange(event);
  };

  // Calculate the displayed vehicles based on the current page and items per page
  const indexOfLastVehicle = currentPage * itemsPerPage;
  const indexOfFirstVehicle = indexOfLastVehicle - itemsPerPage;
  const currentVehicles = filteredVehicles.slice(
    indexOfFirstVehicle,
    indexOfLastVehicle
  );

  // Handle pagination change
  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  return (
    <div>
      <Breadcrumb title="Geofence Allotment to Vehicle" items={BCrumb} />
      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid item xs={4}>
            <Typography
              variant="h2"
              sx={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
                marginTop: "15px;",
                marginBottom: "15px;",
              }}
            >
              Geofence Allotment to Vehicle
            </Typography>
          </Grid>
          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
              marginTop: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/geofencereport");
              }}
            >
              <IconArrowBack width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} style={{ marginTop: "10px" }}>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <CustomFormLabel htmlFor="geofenc_id">
                Geo Fence Name <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <Autocomplete
                id="geofenc_id"
                name="geofenc_id"
                options={geofenc}
                getOptionLabel={(option) => `${option.geo_fence_name}`}
                value={
                  geofenc.find((item) => item.id === values.geofenc_id) || null
                }
                onChange={(event, newValue) => {
                  handleChange({
                    target: { name: "geofenc_id", value: newValue?.id || "" },
                  });
                }}
                onBlur={handleBlur}
                renderInput={(params) => (
                  <CustomTextField
                    {...params}
                    error={touched.geofenc_id && Boolean(errors.geofenc_id)}
                    helperText={touched.geofenc_id && errors.geofenc_id}
                    fullWidth
                    variant="outlined"
                    placeholder="Search or select Area"
                  />
                )}
              />
            </Grid>

            <Grid item lg={4} md={4} sm={6} xs={12}>
              <CustomFormLabel htmlFor="alert_short_name">
                Geo Fence Type <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <Autocomplete
                id="alert_short_name"
                name="alert_short_name"
                options={alert_list}
                getOptionLabel={(option) => `${option.alert_name}`}
                value={
                  alert_list.find(
                    (item) => item.alert_short_name === values.alert_short_name
                  ) || null
                }
                onChange={(event, newValue) => {
                  handleChange({
                    target: {
                      name: "alert_short_name",
                      value: newValue?.alert_short_name || "",
                    },
                  });
                }}
                onBlur={handleBlur}
                renderInput={(params) => (
                  <CustomTextField
                    {...params}
                    error={
                      touched.alert_short_name &&
                      Boolean(errors.alert_short_name)
                    }
                    helperText={
                      touched.alert_short_name && errors.alert_short_name
                    }
                    fullWidth
                    variant="outlined"
                    placeholder="Search or select Alert"
                  />
                )}
              />
            </Grid>
          </Grid>

          {/* <Grid item lg={4} md={4} sm={6} xs={12}>
              <CustomFormLabel htmlFor="radius">E-Mail Id</CustomFormLabel>
              <CustomTextField
                id="email_id"
                name="email_id"
                type="email"
                value={values.email_id}
                onChange={handleChange}
                variant="outlined"
                placeholder="Enter Email for alert"
                fullWidth
              />
            </Grid> */}

          {/* <Grid item lg={4} md={6} sm={6} xs={12}>
              <CustomFormLabel htmlFor="alert_status">
                Send Alert <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <Autocomplete
                id="alert_status"
                name="alert_status"
                options={[
                  { label: "Yes", value: 1 },
                  { label: "No", value: 2 },
                ]}
                getOptionLabel={(option) => option.label}
                value={
                  [
                    { label: "Yes", value: 1 },
                    { label: "No", value: 2 },
                  ].find((option) => option.value === values.alert_status) ||
                  null
                }
                onChange={(event, newValue) => {
                  handleChange({
                    target: {
                      name: "alert_status",
                      value: newValue?.value || "",
                    },
                  });
                }}
                onBlur={handleBlur}
                renderInput={(params) => (
                  <CustomTextField
                    {...params}
                    error={touched.alert_status && Boolean(errors.alert_status)}
                    helperText={touched.alert_status && errors.alert_status}
                    fullWidth
                    variant="outlined"
                    placeholder="Select Yes or No"
                  />
                )}
              />
            </Grid> */}
          <Grid container spacing={3} style={{ marginTop: "10px" }}>
            {user_type !== 3 && (
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <CustomFormLabel htmlFor="district_code">
                  District
                </CustomFormLabel>
                <Autocomplete
                  id="district_code"
                  name="district_code"
                  options={districtList}
                  getOptionLabel={(option) => option.district_name}
                  onChange={handleDistrictChange} // Handle district change
                  onBlur={handleBlur}
                  renderInput={(params) => (
                    <CustomTextField
                      {...params}
                      error={
                        touched.district_code && Boolean(errors.district_code)
                      }
                      helperText={touched.district_code && errors.district_code}
                      fullWidth
                      variant="outlined"
                      placeholder="Search or select a District"
                    />
                  )}
                />
              </Grid>
            )}

            <Grid item lg={4} md={4} sm={6} xs={12}>
              <CustomFormLabel htmlFor="radius">
                Search vehicle No
              </CustomFormLabel>
              <CustomTextField
                id="search"
                name="search"
                type="text"
                value={searchQuery} // Bind search query state
                onChange={handleSearchChange} // Handle search input change
                onBlur={handleBlur}
                error={touched.search && Boolean(errors.search)}
                helperText={touched.search && errors.search}
                variant="outlined"
                placeholder="Search vehicle No"
                fullWidth
              />
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <CustomFormLabel htmlFor="vehicle_no">
                Vehicle Number <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>

              <Grid container spacing={3} style={{ marginTop: "10px" }}>
                {currentVehicles.length > 0 ? (
                  currentVehicles.map((vehicle) => (
                    <Grid
                      item
                      lg={2}
                      md={3}
                      sm={4}
                      xs={6}
                      key={vehicle.vehicle_no}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={values.vehicle_no.includes(
                              vehicle.vehicle_no
                            )}
                            onChange={handleChange}
                            name="vehicle_no"
                            value={vehicle.vehicle_no}
                          />
                        }
                        label={`${vehicle.vehicle_no}`}
                      />
                    </Grid>
                  ))
                ) : (
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <h6 style={{ textAlign: "center", color: "red" }}>
                      No Vehicles Found !!
                    </h6>
                  </Grid>
                )}
              </Grid>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Pagination
                count={Math.ceil(filteredVehicles.length / itemsPerPage)}
                page={currentPage}
                onChange={handlePageChange}
                color="primary"
                showFirstButton
                showLastButton
              />
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Button color="success" variant="contained" type="submit">
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </ParentCard>
    </div>
  );
};

export default FencingAllottoMultipleVehicle;
